/**
 * Phone Auth Provider Factory (Web)
 *
 * Returns the Firebase Phone Auth provider for web.
 */

import { PhoneAuthProvider } from '../../../../src/services/phoneAuth/PhoneAuthProvider.interface';
import { FirebasePhoneAuthProviderWeb } from './FirebasePhoneAuthProviderWeb';

export class PhoneAuthProviderFactory {
  /**
   * Create the Firebase phone auth provider for web
   */
  static createProvider(): PhoneAuthProvider {
    console.log('[PhoneAuthFactory] Creating firebase provider for web');
    return new FirebasePhoneAuthProviderWeb();
  }

  static getProviderName(): 'firebase' {
    return 'firebase';
  }

  static isFirebaseEnabled(): boolean {
    return true;
  }
}
